function getBaseURL(host) {
  return 'https://' + host + '.dropboxapi.com/2/';
}

module.exports = getBaseURL;



//////////////////
// WEBPACK FOOTER
// ./~/dropbox/src/get-base-url.js
// module id = 161
// module chunks = 0